import { Link } from "react-router-dom";

export default function AboutHero() {
  const handleScroll = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/41fa56a3aa26f2bd1e7fbb6a63ff1e90.jpg"
          alt="Don Collins Auto Storage facility interior San Rafael"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/85"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-black/30"></div>
      </div>

      {/* Breadcrumb */}
      <div className="absolute top-28 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 font-sans text-xs text-[#9A9A9A]">
          <Link to="/" className="hover:text-gold transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line text-xs"></i>
          <span className="text-gold">About Us</span>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 lg:px-12 max-w-5xl mx-auto">
        <p className="font-sans text-gold text-xs tracking-[0.35em] uppercase font-semibold mb-6">
          Our Story &amp; Mission
        </p>
        <h1 className="font-serif text-white text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
          Built on 65 Years
          <br />
          <em className="text-gold not-italic">of Bay Area Trust.</em>
        </h1>
        <p className="font-sans text-[#C8C8C8] text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto">
          Don Collins Auto Storage was founded on a simple principle: vehicles deserve reliable, secure indoor protection. That commitment lives on today under Jim Long&apos;s ownership.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <button
            onClick={handleScroll}
            className="font-sans text-sm font-semibold bg-gold text-charcoal px-8 py-4 rounded tracking-wide hover:bg-gold-light transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Reserve Storage Space
          </button>
          <a
            href="tel:4154539180"
            className="font-sans text-sm font-medium border border-white/40 text-white px-8 py-4 rounded tracking-wide hover:border-gold hover:text-gold transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm"></i>
            </div>
            Speak With Us
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">
          {[
            { value: "65+", label: "Years of Experience" },
            { value: "2", label: "Bay Area Locations" },
            { value: "100%", label: "Indoor & Alarmed" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <span className="font-serif text-gold text-3xl font-bold block">{stat.value}</span>
              <span className="font-sans text-[#9A9A9A] text-xs tracking-wider uppercase mt-1 block">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-5 h-8 border-2 border-white/30 rounded-full flex items-start justify-center pt-1.5">
          <div className="w-1 h-2 bg-gold rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
